module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Empty List":"Leere Liste","There is nothing to see here!":"Hier gibt es nichts zu sehen!"}}')
  delete Component.options._Ctor
}
